module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.f3a02e25.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Bold.woff2
// module id = 531
// module chunks = 0